<script>
import {mapGetters, mapActions} from "vuex";
import appStatuses from "../../service/contract-statuses";

import AppConfirm from "../../components/modals/app-confirm.vue";
import AdminContractPage from "../../components/AdminContractLotinPage.vue";
import AdminContractSchetSummPage from "~/src/components/AdminContractSchetSummLotinPage.vue";
import AdminContractSchetSummPagePechat from "~/src/components/AdminContractSchetSummLotinPagePechat.vue";
import AdminContractPaidShow2026 from "~/src/components/AdminContractPaidShow2026.vue";
import AdminContractPaidEdit2026 from "~/src/components/AdminContractPaidEdit2026.vue";
import AddGroupNumber2026 from "~/src/components/AddGroupNumber2026.vue";
import AdminContractPaidPayment2026 from "~/src/components/AdminContractPaidPayment2026.vue";
import EditContractNumber2026 from "~/src/components/EditContractNumber2026.vue";
import AdminAddPromotion2026 from "~/src/components/AdminAddPromotion2026.vue";
import axios from 'axios'
import { loadDraft, saveTab, loadTab } from "~/src/utils/contract-edit-draft";
import CreditHistory from "~/src/components/CreditHistory.vue";
import DormitoryHistory from "~/src/components/DormitoryHistory.vue";
import ContractComments from "~/src/components/ContractComments.vue";
import BitrixResendButton from "~/src/components/BitrixResendButton.vue";
import { readableTextOn } from "~/src/utils/readable-text";

export default {
  components: {
    BitrixResendButton,
    AdminContractSchetSummPage,
    AdminContractPaidShow2026,
    AppConfirm,
    AdminContractPage,
    AdminContractPaidEdit2026,
    AddGroupNumber2026,
    AdminContractPaidPayment2026,
    AdminContractSchetSummPagePechat,
    EditContractNumber2026,
    AdminAddPromotion2026,
    CreditHistory,
    DormitoryHistory,
    ContractComments,
  },

  data: () => ({
    tabs: {
      personal: "Personal info",
      edit: "Edit",
      payment: "Payment",
      groupAdd: "Add Group Number",
      editContractNumber: "Contract Number",
      promotion: "VAUCHER",
      credit: "Kredit tarixi",
      dormitory: "Yotoqxona",
    },

    tab: "Personal info",
    loading: false,
    deleteDialog: false,
    isContract: false,
    isInvoice: false,
    isInvoicePechat: false,
    pdfData: null,

    // Comment section state
    comments: [],
    newComment: "",
    postingComment: false,
    loadingComments: false,
    // A MASTER student renders master_template_id(_ru). The documents from Scho't faktura down carry no
    // bachelor/master wording, so masters get the same file as everyone else. "2 tomonlama shartnoma
    // imzosiz" (6000/60001) is written for Bakalavriat and has no master version, so it has no master id.
    buttons: [
      {label: "2 tomonlama shartnoma imzosiz", abit_template_id: 6000, abit_template_ru: 60001},
      {label: "2 tomonlama shartnoma", abit_template_id: 1000, abit_template_ru: 10001, master_template_id: 3000, master_template_id_ru: 3000},
      {label: "3 tomonlama shartnoma imzosiz", abit_template_id: 2000, abit_template_ru: 20001, master_template_id: 2100, master_template_id_ru: 21001},

      // { label: "Atsverka uchun shartnoma", abit_template_id: 4000, abit_template_ru: 40001 },
      {label: "Scho't faktura", abit_template_id: 4000, abit_template_ru: 40001, master_template_id: 4000, master_template_id_ru: 40001},
      {label: "Mahalla uchun shartnoma", abit_template_id: 7000, abit_template_ru: 70001, master_template_id: 7000, master_template_id_ru: 70001},
      {label: "Korzinka uchun shartnoma", abit_template_id: 8000, abit_template_ru: 80001, master_template_id: 8000, master_template_id_ru: 80001},
      {label: "Kredit modul uchun shartnoma", abit_template_id: 5000, abit_template_ru: 50001, master_template_id: 5000, master_template_id_ru: 50001},
      {label: "Bitiruvchi amalyoti", abit_template_id: 11000, abit_template_ru: 11000, master_template_id: 11000, master_template_id_ru: 11000},
      // Malakaviy amaliyot shartnomasi: one Uzbek document, so both languages render the same code.
      {label: "Tashkilot shartnomasi", abit_template_id: 9000, abit_template_ru: 9000, master_template_id: 9000, master_template_id_ru: 9000},
    ],
    credit: "Kredit tarixi",
    canExport: false,
    canDelete: false,
    canUpdate: false,
    canDormitory: false,
    canCreate: false
  }),

  async mounted() {
    this.canExport = await this.hasRole("KONTRAKT_26_27", "EXCEL");
    this.canDelete = await this.hasRole("KONTRAKT_26_27", "DELETE");
    this.canUpdate = await this.hasRole("KONTRAKT_26_27", "UPDATE");
    this.canDormitory = await this.hasRole("YOTOQXONA_26_27", "READ");
    this.canCreate = await this.hasRole("KONTRAKT_26_27", "CREATE");
  },

  computed: {
    ...mapGetters("admin-contracts2026", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
    isAccounter: (vm) => vm.user.role == "ACCOUNTER",
    isAccounterHelper: (vm) => vm.user.role == "ACCOUNTER_HELPER",
    isQabulQiluvchi: (vm) => vm.user.role == "QABUL_QILUVCHI",
    isBitrixObserver: (vm) => vm.user.role == "BITRIX_OBSERVER",
    // Bitrix menejeri is strictly read-only: the record opens, but no button on it acts.
    // Document generation and the comment box are not covered by a CRUD op, so they are gated here.
    isBitrixManager: (vm) => vm.user.role == "BITRIX_MANAGER",

    // Who may push this contract back to Bitrix: the super admin and the Bitrix kuzatuvchisi — the two
    // roles that own the CRM sync. Widening it is a one-line change here.
    canResendBitrix: (vm) => vm.isSupperAdmin || vm.isBitrixObserver,

    applicationStatus() {
      const status = appStatuses.find((x) => x.id == this.application.paidStatus) || {};
      return {
        // Fall back to the raw PaidStatus so a status we have no label for still names
        // itself instead of leaving "Holati:" blank.
        name: status[`name-${this.$i18n.locale}`] || this.application.paidStatus || "",
        color: color(status.id || this.application.paidStatus),
      };

      // The banner is white text on this colour, so a null background paints it
      // white-on-white and it reads as "the banner is missing" - which is exactly what
      // happened to refunded (PaidStatus.REFUNDED) contracts. null is therefore reserved
      // for the one case where there is genuinely nothing to show yet: no status loaded.
      function color(statusName) {
        switch (statusName) {
          case "PAID":
            return "#26d317";
          case "HALF_PAID":
            return "#d8d813";
          case "NOT_PAID":
            return "#Fb0607";
          case "REFUNDED":
            // same red as the "To'lov qaytarilganlar" card on the 2026 contract list
            return "#ef3000";
          default:
            return statusName ? "#616161" : null;
        }
      }
    },
  },


  created() {

    const id = this.$route.params.id;
    if (id != this.application.id) {
      this.INIT_BY_ID({id}).then((status) => {
        if (!status) {
          this.$router.replace("/dashboard");
          return;
        }
        this.openLinkedTab();
      });
    }
    this.loadComments();
  },

  watch: {
    'this.$route.params.id': {
      handler(newId) {
        this.initialize(newId);
      },
      immediate: true,
    },
    tab(v) { const id = this.application?.id; if (id) saveTab(2026, id, v); },
  },

  activated() {
    this.initialize();
  },

  methods: {
    // Dark text on the light status fills (the "Qisman" yellow, the "To'liq" green), white on the rest.
    textOn: readableTextOn,

    ...mapActions("admin-contracts2026", ["INIT_BY_ID", "DELETE_APPLICATION"]),
    ...mapActions("admin-contract2026", ["INIT_APPLICATION", "INIT_HISTORY", "INIT_ADD_GROUP"]),

    async initialize(newId) {
      await this.INIT_BY_ID({ newId });
      await this.restoreDraft();
    },

    async restoreDraft() {
      const id = this.application?.id;
      if (!id) return;
      const draft = loadDraft(2026, id);
      const savedTab = loadTab(2026, id);
      if (draft) {
        await this.INIT_APPLICATION(draft);
        this.tab = this.tabs.edit;
      } else if (savedTab && Object.values(this.tabs).includes(savedTab)) {
        this.tab = savedTab;
        if (savedTab !== this.tabs.personal) {
          await this.INIT_APPLICATION(this.application);
        }
      }
    },

    // /yotoqxona_2026_2027 opens a student with ?tab=yotoqxona. Once the student has loaded, show that
    // tab, and drop the query from the address bar (history.replaceState: the router, and the
    // fullPath-keyed router-view, never see it, so nothing re-mounts). A later reload - the one after
    // a payment is saved - then opens the profile as it always has, not this tab again.
    async openLinkedTab() {
      if (this.$route.query.tab !== "yotoqxona") return;
      window.history.replaceState(window.history.state, "", window.location.pathname);
      if (!(await this.hasRole("YOTOQXONA_26_27", "READ"))) return;
      await this.INIT_APPLICATION(this.application);
      this.tab = this.tabs.dormitory;
    },

    navigateToAdmin() {
      this.$router.go(-1);
    },

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: {appPanel: panel, op}
        });
        return res.data === true;
      } catch {
        return false;
      }
    },

    onCredit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.credit;
      });
    },

    onDormitory() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.dormitory;
      });
    },

    async generateContract(template_id) {
      const contractId = this.application?.id;
      if (!contractId) {
        this.$emit("error", "Contract ID not found.");
        return;
      }

      // A button with no template for this student type (a MASTER on "2 tomonlama shartnoma imzosiz")
      // used to send template_id=undefined and get "undefined is not of type class java.lang.Long"
      // back. Stop before the request and say so, as the 2025 page does.
      if (template_id === undefined || template_id === null) {
        this.$store.dispatch("SET_SNACKBAR", {
          text: this.$t("Bu talaba turi uchun ushbu shartnoma sozlanmagan"),
          color: "error",
        });
        return;
      }

      this.loadingId = template_id;

      try {
        const locale = this.$i18n.locale;
        const res = await axios.get(
            `/admin/contract2026/contract?contract_id=${contractId}&template_id=${template_id}&locale=${locale}`,
            {responseType: "blob"}
        );

        const blob = new Blob([res.data], {type: "application/pdf"});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.application.firstName + " " + this.application.lastName + " " + this.application.middleName}.pdf`;
        link.click();
      } catch (e) {
        console.error(e);
        this.$emit("error", "Xatolik yuz berdi");
      } finally {
        this.loadingId = null;
      }
    },


    formatAcceptedAt(value) {
      // Local dd.MM.yyyy HH:mm from the ISO instant the accept was recorded.
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const p = (n) => String(n).padStart(2, "0");
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },

    getVaucherText(promValue) {
      return promValue <= 100
          ? `Vaucher berilgan, miqdori: ${promValue} %`
          : `Vaucher berilgan, miqdori: ${promValue} so'm`;
    },

    onEdit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.edit;
      });
    },

    onPayment() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.payment;
      });
    },

    onPromotion() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.promotion;
      });
    },

    onDelete() {
      this.loading = true;
      this.DELETE_APPLICATION(this.application).then((status) => {
        this.loading = false;
        if (status) {
          this.$router.replace("/contract_2026_2027");
        }
      });
    },

    onAddModel() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.groupAdd;
      });
    },

    onEditContractNumber() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.editContractNumber;
      });
    },

    async onDownloadContract() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2026/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isContract = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoice() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2026/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isInvoice = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoicePechat() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2026/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isInvoicePechat = true));
      } else {
        this.loading = false;
      }
    },

    // Comment system methods
    async loadComments() {
      this.loadingComments = true;
      try {
        const id = this.$route.params.id;
        this.comments = await this.$axios.$get(`/admin/contract2026/comment?contractId=${id}`);
      } catch (e) {
        console.error("Failed to load comments", e);
      } finally {
        this.loadingComments = false;
      }
    },

    async postComment() {
      if (!this.newComment.trim()) return;
      this.postingComment = true;
      try {
        const dto = {
          contract2026_id: this.$route.params.id,
          comment: this.newComment.trim(),
          firstName: this.user.firstName,
          lastName: this.user.lastName,
        };
        const saved = await this.$axios.$post(`/admin/contract2026/comment`, dto);
        this.comments.unshift(saved);
        this.newComment = "";
      } catch (e) {
        console.error("Comment submission failed", e);
      } finally {
        this.postingComment = false;
      }
    },

    handleContractClick(button) {
      console.log(
          this.application.typeAbiturient === 'MASTER'
              ? 'Master template selected'
              : 'Abiturient template selected'
      );

      const isRusEdu = this.application.educationLanguage?.id === 2;
      const templateId = this.application.typeAbiturient === 'MASTER'
          ? (isRusEdu ? button.master_template_id_ru : button.master_template_id)
          : (isRusEdu ? button.abit_template_ru : button.abit_template_id);

      this.generateContract(templateId);
    }


  },
};
</script>

<template>
  <div class="pb-5">


    <admin-contract-page
        v-if="isContract && pdfData"
        :pdfData="pdfData"
        @close="
          () => {
            isContract = false;
            loading = false;
          }
        "
    />

    <admin-contract-schet-summ-page
        v-if="isInvoice && pdfData"
        :pdfData="pdfData"
        @close="
        () => {
          isInvoice = false;
          loading = false;
        }
      "
    />

    <admin-contract-schet-summ-page-pechat
        v-if="isInvoicePechat && pdfData"
        :pdf-data="pdfData"
        @close="
        () => {
          isInvoicePechat = false;
          loading = false;
        }
      "
    />


    <app-confirm
        v-if="canDelete"
        v-model="deleteDialog"
        :text="$t('Do you really want to delete?')"
        @accept="onDelete"
    />


    <v-container style="display: flex;">
      <v-btn
          @click="navigateToAdmin"
          elevation="0"
          rounded
          large
          class="font-made modern-back-btn mb-6 px-6 py-3 d-flex align-center"
          style="
          border: 1px solid #e0e0e0;
          background: linear-gradient(135deg, #ffffff, #f9f9f9);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.25s ease;
        "
      >
        <v-icon
            left
            size="22"
            style="color:#0c0c0c; transition: transform 0.2s;"
            class="back-icon"
        >
          mdi-arrow-left
        </v-icon>
        <span
            class="font-weight-bold text-uppercase"
            style="letter-spacing:1px; font-size:14px; color:#0c0c0c;"
        >
          {{ $t("Back") }}
        </span>
      </v-btn>

      <div class="-status-wrap" style="width: 100%; height: 100%;">

        <div
            class="-status"
            :style="{ backgroundColor: applicationStatus.color, color: textOn(applicationStatus.color) }"
        >
          {{ application.kurs }} - {{ $t("kurs talabasi") }}, {{ $t("Status") }}:
          {{ applicationStatus.name }}, {{ $t("Kontract summasi") }}
          {{ $comma(application.totalSumma) }}, {{ $t("Qoldiq") }}
          {{ $comma(application.totalOstatok) }}
        </div>
      </div>
    </v-container>


    <!-- ── To'ldiruvchi (who filled the form) ──
         filledBy is set only when a Qabul/Call-markaz operator filled the form at the /admission desk;
         a self-registered student has none, so the card simply does not render for them. Reuses the
         .cm-by attribution card in its brass "filled" variant (a set filledBy always means staff). -->
    <v-container v-if="application && application.filledBy" class="py-0">
      <div class="cm-by cm-by--filled">
        <div class="cm-by-glyph">
          <v-icon size="22">mdi-account-edit</v-icon>
        </div>
        <div class="cm-by-body">
          <div class="cm-by-eyebrow">{{ $t("Filled by") }}</div>
          <div class="cm-by-name">{{ application.filledBy }}</div>
        </div>
        <div class="cm-by-badge">{{ $t("Filled by") }}</div>
      </div>
    </v-container>

    <!-- ── Call-markaz manager ──
         Read from the contract's own snapshot (callManagerName), so it shows even after the application
         is deleted; the "Call markaz #id" fallback is already baked into the stored value. Coloured by
         who FILLED the form (filledBy → brass, self-registered → dark). -->
    <v-container v-if="application && application.callManagerName" class="py-0">
      <div class="cm-by" :class="{ 'cm-by--filled': !!application.filledBy }">
        <div class="cm-by-glyph">
          <v-icon size="22">mdi-headset</v-icon>
        </div>
        <div class="cm-by-body">
          <div class="cm-by-eyebrow">{{ $t("Call markaz xodimi") }}</div>
          <div class="cm-by-name">{{ application.callManagerName }}</div>
        </div>
        <div class="cm-by-badge">{{ $t("Call markaz") }}</div>
      </div>
    </v-container>

    <!-- ── Biriktirilgan menejer (Bitrix ASSIGNED_BY_ID) ──
         Who the student's Bitrix DEAL is assigned to, which is a different thing from the Call-markaz
         card above: that one is only the ?manager_id= link the student arrived through and covers a
         small minority of rows, while nearly every deal has an assignee. Name only — the Bitrix user
         id is internal and never rendered. Read from the contract's own snapshot column so it survives
         the application being deleted. -->
    <v-container v-if="application && application.assignedManagerName" class="py-0">
      <div class="cm-by">
        <div class="cm-by-glyph">
          <v-icon size="22">mdi-account-tie</v-icon>
        </div>
        <div class="cm-by-body">
          <div class="cm-by-eyebrow">{{ $t("Biriktirilgan menejer") }}</div>
          <div class="cm-by-name">{{ application.assignedManagerName }}</div>
        </div>
        <div class="cm-by-badge">{{ $t("Bitrix") }}</div>
      </div>
    </v-container>

    <!-- ── Qabul xodimi (referral employee) ──
         Snapshotted onto the contract (referralEmployeeName), so it survives application deletion.
         Dark card (this is who BROUGHT the student, not who filled the form). -->
    <v-container v-if="application && application.referralEmployeeName" class="py-0">
      <div class="cm-by">
        <div class="cm-by-glyph">
          <v-icon size="22">mdi-account-tie</v-icon>
        </div>
        <div class="cm-by-body">
          <div class="cm-by-eyebrow">{{ $t("Qabul xodimi") }}</div>
          <div class="cm-by-name">{{ application.referralEmployeeName }}</div>
        </div>
        <div class="cm-by-badge">{{ $t("Qabul") }}</div>
      </div>
    </v-container>

    <!-- ── Taklif qilgan talaba (?student=) ──
         Unlike the three cards above this has no snapshot column on the contract — it is read live
         through applicationId, so it shows while that application row exists. -->
    <v-container v-if="application && application.invitedByStudent" class="py-0">
      <div class="cm-by">
        <div class="cm-by-glyph">
          <v-icon size="22">mdi-school</v-icon>
        </div>
        <div class="cm-by-body">
          <div class="cm-by-eyebrow">{{ $t("Taklif qilgan talaba") }}</div>
          <div class="cm-by-name">{{ application.invitedByStudent.fullName }}</div>
          <div class="cm-by-meta" v-if="application.invitedByStudent.phone">
            {{ application.invitedByStudent.phone }}
          </div>
        </div>
        <div class="cm-by-badge">{{ $t("Talaba") }}</div>
      </div>
    </v-container>

    <!-- Who pressed "Qabul qilish" for this contract, and when. -->
    <v-container v-if="application && application.acceptedBy" class="py-0">
      <div class="accepted-by">
        <v-icon size="18" class="accepted-by-icon">mdi-account-check</v-icon>
        <span class="accepted-by-label">{{ $t("Accepted by") }}:</span>
        <span class="accepted-by-name">{{ application.acceptedBy }}</span>
        <span v-if="application.acceptedAt" class="accepted-by-date">
          · {{ formatAcceptedAt(application.acceptedAt) }}
        </span>
      </div>
    </v-container>

    <!-- The Bitrix user this student's DEAL is assigned to (ASSIGNED_BY_ID), read from the
         contract's own assigned_manager_name snapshot so it survives the application being
         deleted. Same slim strip as "Qabul qilgan xodim" above, blue rather than green so the
         pair reads as two different facts; the cm-by card higher up carries the same name. -->
    <v-container v-if="application && application.assignedManagerName" class="py-0">
      <div class="accepted-by">
        <v-icon size="18" class="accepted-by-icon assigned-mgr-icon">mdi-account-tie</v-icon>
        <span class="accepted-by-label">{{ $t("Biriktirilgan menejer") }}:</span>
        <span class="accepted-by-name">{{ application.assignedManagerName }}</span>
        <span class="accepted-by-date">· {{ $t("Bitrix") }}</span>
      </div>
    </v-container>

    <v-container>
      <div class="-status-wrap" style="width: 100%; height: 100%;">
        <div
            :style="{ backgroundColor: 'green' }"
            v-if="application.promotion > 0"
            class="-status"
            v-text="getVaucherText(application.promotion)"
        />
      </div>
    </v-container>

    <v-container class="-wrap">
      <div class="pa-5">
        <div header>
          <div class="title pb-2 text-center accent--text tab-title brand-title" v-text="$t(tab)"/>


          <div class="title-actions pb-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    elevation="0"
                    color="accent"
                    @click="tab = tabs.personal"
                    :outlined="tab != tabs.personal"
                    class="px-0"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon> mdi-badge-account-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Personal info") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onEdit"
                    :outlined="tab != tabs.edit"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onCredit"
                    :outlined="tab != tabs.credit"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>Kredit tarixi</span>
            </v-tooltip>

            <v-tooltip
                bottom
                v-if="canDormitory"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onDormitory"
                    :outlined="tab != tabs.dormitory"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <img class="bed-icon" :src="tab == tabs.dormitory ? '/icons/nav-bed.svg' : ($vuetify.theme.dark ? '/icons/nav-bed-yellow.svg' : '/icons/nav-bed-dark.svg')" alt="Yotoqxona"/>
                </v-btn>
              </template>
              <span>Yotoqxona</span>
            </v-tooltip>

            <v-tooltip
                bottom
                v-if="canUpdate"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onPromotion"
                    :outlined="tab != tabs.promotion"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("promotion") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canCreate" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onPayment"
                    :outlined="tab != tabs.payment"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Payment") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canUpdate" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onAddModel"
                    :outlined="tab != tabs.groupAdd"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5">
                  <v-icon> mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Add Group Number") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onEditContractNumber"
                    :outlined="tab != tabs.editContractNumber"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5">
                  <v-icon> mdi-file-document-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit Contract Number") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canDelete"
                       bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    large
                    color="red darken-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="deleteDialog = true"
                >
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>

            <v-tooltip v-if="!isBitrixManager" bottom>
              <template v-slot:activator="{ on, attrs }" v-if="application.paidStatus !== 'PAID'">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="generateContract(application.typeAbiturient === 'MASTER' ? 3000 : (application.educationLanguage && application.educationLanguage.id === 2 ? 10001 : 1000))"
                >
                  <v-icon> mdi-file-pdf</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet_pechat") }}</span>
            </v-tooltip>

            <!-- Re-send THIS contract's Bitrix requests, pushed to the far right of the action row.
                 contractId (not applicationId) is passed on purpose: the server then builds the field
                 events from the CONTRACT row, so edits made here AFTER the student moved to
                 /contract_2026_2027 are what reaches Bitrix.
                 Shown ONLY when the student really exists in /applications (applicationExists): a contract
                 with a dangling appication_id is never synced to Bitrix, so the button would do nothing. -->
            <bitrix-resend-button
                v-if="canResendBitrix && application && application.id && application.applicationExists"
                class="bitrix-resend-slot"
                :contract-id="application.id"
            />
          </div>

          <!-- Where this student came from. excelImported is enriched server-side through
               applicationId, since contract2026 keeps no source column of its own. -->
          <div v-if="application && application.excelImported" class="excel-pill">
            <v-icon size="15" color="#fff" class="mr-1">mdi-microsoft-excel</v-icon>
            {{ $t('EXCEL ORQALI YUKLANGAN') }}
          </div>

          <div v-if="!isBitrixManager" class="d-flex flex-wrap justify-start align-center">
            <v-btn
                v-for="(button, index) in buttons"
                :key="index"
                class="contract-btn ma-2"
                outlined
                tile
                @click="handleContractClick(button)"
            >
              {{ button.label }}
            </v-btn>
          </div>


          <div class="position-relative">
            <v-progress-linear
                top
                absolute
                :active="loading"
                indeterminate
                posi
            />


          </div>


          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt=""/>
          </div>
        </div>

        <div body class="pt-5">
          <admin-contract-paid-show2026 v-if="tab == tabs.personal"/>
          <admin-contract-paid-edit2026 v-else-if="tab == tabs.edit"/>
          <add-group-number2026 v-else-if="tab == tabs.groupAdd"/>
          <AdminContractPaidPayment2026 v-else-if="tab == tabs.payment"/>
          <EditContractNumber2026 v-else-if="tab == tabs.editContractNumber"/>
          <AdminAddPromotion2026 :contract="application" v-else-if="tab == tabs.promotion"/>

          <CreditHistory
              v-else-if="tab == tabs.credit"
              :contract-id="application.id"
              :contract-number="application.contractNumber"
              :study-year="'2026-2027'"
              :permission-panel="'KONTRAKT_26_27'"
              :api-base="'/credit/history'"
              :application="application"
          />

          <DormitoryHistory
              v-else-if="tab == tabs.dormitory"
              :contract-id="application.id"
              :contract-number="application.contractNumber"
              :application="application"
          />

        </div>
      </div>

    </v-container>

    <!-- <v-container class="mt-10">
      <v-card outlined>
        <v-card-title>
          <span class="text-h6">Comments</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-textarea
            v-model="newComment"
            label="Write a comment..."
            auto-grow
            rows="1"
            :disabled="postingComment"
            class="mb-4"
          ></v-textarea>
          <v-btn
            color="primary"
            @click="postComment"
            :loading="postingComment"
            :disabled="!newComment.trim()"
          >
            Post
          </v-btn>

          <v-divider class="my-4" />

          <v-skeleton-loader v-if="loadingComments" type="list-item@3" />
          <div v-else>
            <div v-for="(comment, index) in comments" :key="index" class="mb-4">
              <div class="font-weight-bold mb-1">
                {{ comment.firstName }} {{ comment.lastName }}
              </div>
              <div class="grey--text">
                {{ comment.comment }}
              </div>
              <v-divider class="my-3" />
            </div>
            <div v-if="comments.length === 0" class="grey--text text-center">
              No comments yet.
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-container> -->

    <!-- px-0: the card spans the same edges as the grey panel above (a container pads 12px a side). -->
    <v-container class="px-0">
      <contract-comments
          :contract-id="application?.id || Number($route.params.id)"
          :api-base="'admin/contract2026/comment'"
          :page-size="20"
          :infinite="true"
          :current-user="{ firstName: user.firstName, lastName: user.lastName }"
          :allow-all-edits="isSupperAdmin || isAccounter || isAccounterHelper || isQabulQiluvchi"
          :readonly="isBitrixManager"
          @loaded="evt => { /* optional badge refresh */ }"
          @count="n => { /* store if needed */ }"
          @changed="evt => { /* handle create/update/delete */ }"
          @error="e => { console.error('comments error', e) }"

          :current-user-id="user.id"
          :current-user-roles="user.roles"

      />

    </v-container>


  </div>
</template>

<style lang="scss" scoped>
.-status-wrap {
  display: flex;
  justify-content: center;

  .-status {
    padding: 8px 5px;
    border-radius: 10px;
    margin-left: 35px;
    margin-right: 35px;
    width: 100%;
    text-align: center;
    cursor: default;
    font-size: 18px;
    color: white;
  }
}

.-wrap {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;

  .title-actions {
    // Was a plain block of inline v-tooltip activators; flex reproduces that single left-aligned row
    // (the buttons keep their own ml-5 margins) and is what lets the Bitrix re-send sit at flex-end.
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 10px;

    .v-btn {
      min-width: 44px;
    }

    // flex-end for this one item: everything else stays left, this is pushed to the right edge.
    .bitrix-resend-slot {
      margin-left: auto;
    }
  }
}

@media (max-width: 600px) {
  // No room to sit beside ten icon buttons on a phone — drop it onto its own full-width line instead
  // of letting margin-left:auto squeeze it against the edge.
  .-wrap .title-actions .bitrix-resend-slot {
    margin-left: 0;
    width: 100%;
  }
}

.contract-btn {
  font-weight: 600;
  font-size: 14px;
  border-radius: 14px;
  border: 1px solid #d5dbe0;
  color: #2c3e50;
  background-color: #f9f9f9;
  text-transform: none;
  min-width: 200px;
  height: 46px;
}

.modern-back-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.modern-back-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.back-icon:hover {
  transform: translateX(-3px);
}

/* ── Call-markaz attribution card ──
   Matches the /applications detail card. Dark navy by default (student self-registered),
   #544233 when a Qabul/Call-markaz operator filled the form at the /admission desk; both
   variants are dark, so that one carries white text with white glyph and badge chips. */
.cm-by {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 14px;
  padding: 16px 20px;
  border-radius: 16px;
  background: linear-gradient(135deg, #0c1322 0%, #14203a 60%, #0c1322 100%);
  border: 1px solid rgba(255, 206, 74, 0.35);
  box-shadow: none !important;
}
.cm-by-glyph {
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #ffe07a, #f4a915);
}
.cm-by-glyph .v-icon {
  color: #1a1304 !important;
}
.cm-by-body {
  flex: 1;
  min-width: 0;
}
.cm-by-eyebrow {
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: #ffce4a;
}
.cm-by-name {
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Phone under the name — only the Taklif qilgan talaba card carries one. */
.cm-by-meta {
  margin-top: 3px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.66);
}
.cm-by-badge {
  flex-shrink: 0;
  align-self: flex-start;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #1a1304;
  background: #ffce4a;
  padding: 4px 10px;
  border-radius: 8px;
}
.cm-by--filled {
  background: #544233;
  border-color: rgba(255, 255, 255, 0.28);
  box-shadow: none !important;
}
.cm-by--filled .cm-by-glyph {
  background: #ffffff;
}
.cm-by--filled .cm-by-glyph .v-icon {
  color: #544233 !important;
}
.cm-by--filled .cm-by-eyebrow {
  color: #ffffff;
}
.cm-by--filled .cm-by-name {
  color: #ffffff;
}
.cm-by--filled .cm-by-badge {
  color: #544233;
  background: #ffffff;
}

/* ── Accepted-by line ── */
.accepted-by {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 14px;
  border-radius: 10px;
  background: #f4f6f9;
  border: 1px solid #e6e8ec;
  font-size: 13px;
  color: #3a3f4a;
}
.accepted-by-icon {
  color: #2e7d32 !important;
}
.accepted-by-label {
  font-weight: 600;
  color: #6b7280;
}
.accepted-by-name {
  font-weight: 700;
  color: #0c1322;
}
.accepted-by-date {
  color: #8a8f99;
}
.theme--dark .accepted-by {
  background: #161b28;
  border-color: #2a3144;
  color: #c9ccd6;
}
.theme--dark .accepted-by-label {
  color: #8a8fa3;
}
.theme--dark .accepted-by-name {
  color: #e4e5eb;
}
.theme--dark .accepted-by-date {
  color: #8a8fa3;
}
/* Biriktirilgan menejer reuses the whole .accepted-by strip; only the glyph differs, so the two
   strips are told apart at a glance instead of by reading the label. */
.assigned-mgr-icon {
  color: #1f6feb !important;
}
/* Excel green, matching the pill on /application-show and the import button on /applications. */
.excel-pill {
  display: inline-flex;
  align-items: center;
  background: #217346;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .3px;
  padding: 5px 12px;
  border-radius: 999px;
  margin: 8px 0 4px;
}
.bed-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
}
</style>
  